import { render, staticRenderFns } from "./TalentManagerDashboard.vue?vue&type=template&id=4affb720&scoped=true&"
import script from "./TalentManagerDashboard.vue?vue&type=script&lang=ts&"
export * from "./TalentManagerDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./TalentManagerDashboard.vue?vue&type=style&index=0&id=4affb720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4affb720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
